import { useSyncExternalStore } from "react";

let isOpen = false;
const listeners = new Set<() => void>();

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot() {
  return isOpen;
}

function setOpen(next: boolean) {
  if (isOpen === next) return;
  isOpen = next;
  for (const listener of listeners) listener();
}

export function toggleComposerStrip() {
  setOpen(!isOpen);
}

const autoOpenedStages = new Set<"warning" | "exhausted">();

// Opens once per stage per page load so a dismissed strip stays closed across
// chats until the next stage.
export function autoOpenComposerStrip(stage: "warning" | "exhausted") {
  if (autoOpenedStages.has(stage)) return;
  autoOpenedStages.add(stage);
  setOpen(true);
}

function close() {
  setOpen(false);
}

// No editable-target guard, so it toggles while the chat input is focused; match
// on e.code because Shift turns the "." key's e.key into ">".
document.addEventListener("keydown", (e: KeyboardEvent) => {
  if ((e.metaKey || e.ctrlKey) && e.shiftKey && e.code === "Period") {
    e.preventDefault();
    toggleComposerStrip();
  }
});

export function useComposerStrip() {
  const open = useSyncExternalStore(subscribe, getSnapshot);
  return { open, toggle: toggleComposerStrip, close };
}
